import { getComposeStore } from 'owa-calendar-compose-store-manager';
import {
    getComposeHostItemIndex,
    lazyOnLaunchEventTriggered,
    lazyTriggerRecipientsChangedEvent,
    RecipientFieldEnum,
} from 'owa-addins-core';
import { refreshTimeSuggestions } from 'owa-calendar-time-suggestions';
import refreshLocationSuggestions from './refreshLocationSuggestions';
import { getRecipientInfosAndAttachmentWell } from './getRecipientInfosAndAttachmentWell';
import { lazyTryCheckPermForLinks } from 'owa-recipient-permission-checker';
import { getOpxHostApi } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import isNewEvent from 'owa-calendar-compose-form-store/lib/selectors/isNewEvent';
import updateOnlineMeetingOnRecipientsChanged from './updateOnlineMeetingOnRecipientsChanged';
import { isFeatureEnabled } from 'owa-feature-flags';
import LaunchEventType from 'owa-service/src/contract/LaunchEventType';

export default async function triggerRecipientsChanged(recipientField: RecipientFieldEnum) {
    const { event } = getComposeStore();
    const calendarEvent = event;
    const hostItemIndex = getComposeHostItemIndex(calendarEvent.ParentFolderId.Id);
    const result = {
        requiredAttendees: recipientField === RecipientFieldEnum.RequiredAttendees,
        optionalAttendees: recipientField === RecipientFieldEnum.OptionalAttendees,
        resources: recipientField === RecipientFieldEnum.Resources,
    };

    if (
        isFeatureEnabled('addin-autoRun') &&
        isFeatureEnabled('addin-autoRun-recipientsAttendeesChangeEvent')
    ) {
        lazyOnLaunchEventTriggered.importAndExecute(
            hostItemIndex,
            LaunchEventType.OnAppointmentAttendeesChanged,
            { type: 'olkRecipientsChanged', changedRecipientFields: result }
        );
    }

    lazyTriggerRecipientsChangedEvent
        .import()
        .then(triggerRecipientsChangedEvent =>
            triggerRecipientsChangedEvent(hostItemIndex, result)
        );

    // Refresh suggestions if we are in full compose form or quick compose
    if (recipientField === RecipientFieldEnum.Resources) {
        refreshTimeSuggestions(event, false /* attendeesChanged */);
    } else {
        refreshTimeSuggestions(event, true /* attendeesChanged */);
        updateOnlineMeetingOnRecipientsChanged(event);
    }

    refreshLocationSuggestions();

    const [recipientInfos, attachmentWell] = await getRecipientInfosAndAttachmentWell();
    if (recipientInfos && attachmentWell) {
        lazyTryCheckPermForLinks.importAndExecute(
            attachmentWell.sharingLinkIds,
            recipientInfos,
            attachmentWell.composeId,
            true /* isCalendar */
        );
    }

    if (isHostAppFeatureEnabled('navigateToView')) {
        // If it is opx scenario, make sure we update the host's Send/Save button
        const opxHostApi = getOpxHostApi();
        if (opxHostApi.navigateToView) {
            opxHostApi.navigateToView(
                isNewEvent() ? 'ComposeForm' : 'EditForm',
                isEventAMeeting(event) ? 'Send' : 'Save',
                event
            );
        }
    }
}
